<div class="search-bar">
  <glxy-form-field prefixIcon="search">
    <input
      matInput
      type="search"
      placeholder="Search integrations"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchChange($event)"
    />
  </glxy-form-field>
</div>
